import {
  Card,
  CardContent,
  CircularProgress,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import CssBaseline from '@material-ui/core/CssBaseline'
import { useEffect, useState } from 'react'
import {
  FiArrowRight,
  FiInfo,
  FiMail,
  FiSmartphone,
  FiMessageCircle,
  FiPhone
} from 'react-icons/fi'
import { FaWhatsapp, FaRegEnvelopeOpen } from 'react-icons/fa'
import HeaderMfa from 'src/components/mfa/header'
import LoadingPage from 'src/components/pages/LoadingPage'
import UBox from 'src/components/ui/Ubox'
import { showNotificationErrorAPI } from 'src/core/helpers/notification'
import useAuth from 'src/hooks/useAuth'
import { CanalDisponivel } from 'src/types'
import { useStyles } from './styles'
import { SynRoutes } from 'src/core/consts/synRoutes'
import { useHistory } from 'react-router-dom'
import { Alert } from '@material-ui/lab'

// Enum para os tipos de canal
const CanalEnum = {
  EMAIL: 1,
  SMS: 2,
  WHATSAPP: 3
}

export default function MfaEtapa1() {
  const classes = useStyles()
  const history = useHistory()
  const [canalSelecionado, setCanalSelecionado] = useState<CanalDisponivel>(
    null
  )
  const theme = useTheme()
  const ehXS = useMediaQuery(theme.breakpoints.down('sm'))
  const {
    storageMfaEtapa1Data,
    enviarCodigoMFA,
    loadingEnvioCodigoMFA,
    signOut,
    signed
  } = useAuth()
  // Usar dados do contexto Auth ou dados mock se não disponível
  useEffect(() => {
    if (!storageMfaEtapa1Data) {
      if (signed) {
        history.push(SynRoutes.home)
      } else {
        // signOut()
      }
    }
  }, [storageMfaEtapa1Data, signed])

  const getCanalIcon = (canalEnum: number) => {
    switch (canalEnum) {
      case CanalEnum.EMAIL:
        return <FaRegEnvelopeOpen />
      case CanalEnum.SMS:
        return <FiSmartphone />
      case CanalEnum.WHATSAPP:
        return <FaWhatsapp />
      default:
        return <FiMail />
    }
  }

  const getCanalDescription = (canal: CanalDisponivel) => {
    switch (canal.canalEnum) {
      case CanalEnum.EMAIL:
        return (
          <Typography variant="body2">
            Enviar o código no email: {ehXS && <br />}{' '}
            {canal.contatoAnonimizado}
          </Typography>
        )
      case CanalEnum.SMS:
        return (
          <Typography variant="body2">
            Enviar o código no número: {ehXS && <br />}{' '}
            {canal.contatoAnonimizado}
          </Typography>
        )
      case CanalEnum.WHATSAPP:
        return (
          <Typography variant="body2">
            Enviar o código no número: {ehXS && <br />}{' '}
            {canal.contatoAnonimizado}
          </Typography>
        )
      default:
        return canal.contatoAnonimizado
    }
  }

  const handleEnviarCodigoMFA = async (canal: CanalDisponivel) => {
    try {
      setCanalSelecionado(canal)
      await enviarCodigoMFA(canal)
    } catch (error) {
      showNotificationErrorAPI(error)
    }
  }

  if (signed || !storageMfaEtapa1Data) {
    return <LoadingPage />
  }

  return (
    <div className={'fadeInTransition syn-container-out'}>
      <CssBaseline />
      <HeaderMfa />

      {/* Main Content */}
      <div className={classes.mfaBox}>
        <UBox style={{ textAlign: 'center' }}>
          <Typography variant="h5" color="primary">
            <strong>Código de Autenticação</strong>
          </Typography>

          <Typography variant="body1" color="primary">
            Selecione como deseja receber seu código de autenticação.
          </Typography>
        </UBox>

        {/* Canais Disponíveis */}
        <UBox mt={4} width="100%">
          {storageMfaEtapa1Data?.canaisDisponiveis.map((canal, index) => (
            <Card
              key={index}
              className={classes.canalCard}
              onClick={() =>
                !loadingEnvioCodigoMFA && handleEnviarCodigoMFA(canal)
              }
            >
              <CardContent className={classes.canalContent}>
                <div className={classes.canalIcon}>
                  {getCanalIcon(canal.canalEnum)}
                </div>
                <div className={classes.canalInfo}>
                  <Typography className={classes.canalTitle} variant="body2">
                    Receber no {canal.canalDescricao}
                  </Typography>
                  <Typography className={classes.canalDescription}>
                    {getCanalDescription(canal)}
                  </Typography>
                </div>
                {!loadingEnvioCodigoMFA && (
                  <FiArrowRight className={classes.canalArrow} />
                )}
                {loadingEnvioCodigoMFA &&
                  canalSelecionado?.canalEnum === canal.canalEnum && (
                    <div>
                      Enviando... <CircularProgress size={16} />
                    </div>
                  )}
              </CardContent>
            </Card>
          ))}
        </UBox>
        {/* Seção de Ajuda */}
        <Alert severity="info" style={{ width: '100%' }}>
          <Typography className={classes.helpText}>
            Não consegue acessar?
          </Typography>
          <Typography className={classes.helpSubtext}>
            Entre em contato com o hospital responsável pela sua conta de
            acesso.
          </Typography>
        </Alert>
      </div>
    </div>
  )
}
